/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/styles/globals.css"
import React from 'react';
import { LanguageProvider } from './src/context/LanguageContext';
import AuthProvider from './src/context/auth-context';
import LoadingProvider from './src/context/loading-context';

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>
    <LoadingProvider>
      <AuthProvider>{element}</AuthProvider>
    </LoadingProvider>
  </LanguageProvider>
);

// Preload critical resources
export const onClientEntry = () => {
  // HubSpot chat is human backup only — do not auto-load the Sales Agent launcher
  if (typeof window !== 'undefined') {
    window.hsConversationsSettings = Object.assign({}, window.hsConversationsSettings || {}, {
      loadImmediately: false,
    });
    document.documentElement.setAttribute('data-hubspot-chat', 'hidden');
  }

  // Preconnect to external domains for faster resource loading
  const preconnectDomains = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://www.googletagmanager.com',
    'https://www.google.com',
    'https://www.gstatic.com',
  ];
  
  preconnectDomains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// Smooth scroll behavior
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Scroll to anchor if hash exists
  if (location.hash) {
    const element = document.querySelector(location.hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      return false;
    }
  }
  
  // Otherwise scroll to top
  window.scrollTo(0, 0);
  return false;
}; 